<template>
  <div>
  <Card>
      <Row>
        <i-col span="18">
          <Form ref="searchForm" inline :model="searchForm" :label-width="60" @submit.native.prevent>
            <FormItem label="用户名" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入用户名" style="width: 200px;"></i-input>
            </FormItem>
            <FormItem :label-width="0">
              <Button type="primary" @click="getSystemUserList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col span="6">
          <Button style="float: right;" @click="addUser" type="primary" :style="{marginBottom: '10px'}">添加</Button>
        </i-col>
       </Row>
      <tables search-place="top" v-model="tableData" :columns="columns" @on-sort-change="changeSort"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getSystemUserList"></page>
        </div>
     </Row>
      <Drawer
        title="添加"
        v-model="change"
        width="720"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="100" :rules="ruleValidate">
          <form-item label="系统用户名" prop="username">
            <i-input  v-model="formItem.username" placeholder="输入系统用户名"></i-input>
          </form-item>
         <form-item label="操作系统" prop="os">
             <i-select v-model="formItem.os"  style="width: 90%;" @on-change="onSelectOs">
                  <Option value="0">Linux</Option>
                  <Option value="1">Windows</Option>
             </i-select>
          </form-item>
         <form-item label="描述" prop="description" >
            <i-input  v-model="formItem.description" placeholder="请输入描述信息" ></i-input>
          </form-item>
          <form-item label="密钥修改" v-show="keyEditVisible">
              <RadioGroup v-model="keyInitValue" @on-change="onSelectKey">
                <Radio label="0">不修改</Radio>
                <Radio label="1">指定密钥</Radio>
                <Radio label="2">随机生成密钥</Radio>
              </RadioGroup>
          </form-item>
          <form-item label="密钥" prop="private_key" v-show="keyVisible">
            <i-input  v-model="formItem.private_key" placeholder="请粘贴私钥" type="textarea" :autosize="{minRows: 25,maxRows: 25}" ></i-input>
          </form-item>
          <FormItem label="sudo权限" prop="sudo" v-show="sudoVisible">
             <i-input  v-model="formItem.sudo" placeholder="请指定权限" ></i-input>
          </FormItem>
        <FormItem label="shell" prop="shell" v-show="shellVisible">
             <i-input  v-model="formItem.shell" placeholder="请指定登陆shell" ></i-input>
          </FormItem>
          <form-item>
           <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
           <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
      <Drawer
        title="推送系统用户"
        v-model="changePush"
        width="720"
        :mask-closable="true"
        @on-close="drawerPushClose"
      >
         <i-form ref="formItemPush" :model="formItemPush" :label-width="100" :rules="ruleValidatePush">
          <form-item label="系统用户名" prop="system_user_name">
            <i-input  v-model="formItemPush.system_user_name" disabled></i-input>
          </form-item>
          <form-item label="资产" prop="assets">
            <i-select v-model="formItemPush.assets"  multiple  style="width: 90%;">
              <i-option v-for="item in assetOptions" :value="item.id" :key="item.id" :label="item.inner_ip"></i-option>
            </i-select>
          </form-item>
          <form-item label="连接方式">
            <Checkbox label="使用密钥" disabled v-model="connectWay">Linux默认使用系统用户密钥 | Windows使用主机默认绑定的凭证</Checkbox>
          </form-item>
          <form-item>
           <i-button type="primary" @click="handlePushSubmit('formItemPush')">推送</i-button>
           <i-button style="margin-left: 8px" @click="changePush=false">取消</i-button>
          </form-item>
        </i-form>
     </Drawer>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getSysUserList, saveSysUser, deleteSysUser, editSysUser, getSysUserDetail, pushSysUser } from '@/api/springboard'
import { getOpsCenterAllServer } from '@/api/opscenter'
export default {
  name: 'SystemUserList',
  components: {
    Tables
  },
  data () {
    return {
      // hosts: [{
      //   title: 'parent 1',
      //   expand: true,
      //   children: [
      //     {
      //       title: 'parent 1-1'
      //     }
      //   ]
      // }],
      assetOptions: [],
      count: 1,
      size: 10,
      page: 1,
      change: false,
      changePush: false,
      ordering: null,
      keyInitValue: '2',
      keyVisible: false,
      connectWay: true,
      sudoVisible: true,
      keyEditVisible: true,
      shellVisible: true,
      columns: [
        { title: 'ID', key: 'id', align: 'center', sortable: 'custom' },
        { title: '系统用户', key: 'username', align: 'center' },
        { title: '权限', key: 'sudo', align: 'center' },
        { title: '添加时间', key: 'time_add', align: 'center' },
        { title: '添加人', key: 'user_add', align: 'center' },
        {
          title: '操作',
          align: 'center',
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    title: '推送',
                    disabled: params.row.btnEnabled
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.pushUser(params)
                    }
                  }
                }, '推送'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    title: '编辑'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editUser(params)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?',
                    transfer: true
                  },
                  on: {
                    'on-ok': () => {
                      this.deleteUser(params.row.id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small',
                      title: 'Delete'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }, 'Delete')
                ])
              ])
            } else {}
          }
        }
      ],
      tableData: [],
      user_all: [],
      changeLoadingShow: false,
      searchForm: {
        name: null
      },
      formItem: {
        id: null,
        username: '',
        name: '',
        description: '',
        private_key: '',
        sudo: '/sbin/ifconfig',
        shell: '/bin/bash',
        os: '0'
      },
      formItemPush: {
        system_user: null,
        system_user_name: '',
        assets: []
      },
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidate: {
        username: [{ required: true, message: '用户不能为空 !', trigger: 'blur' }],
        sudo: [{ required: true, message: '请指定权限', trigger: 'blur' }],
        shell: [{ required: true, message: '请指定登陆shell', trigger: 'blur' }]
      },
      ruleValidatePush: {
      }
    }
  },
  methods: {
    getSystemUserList (value = 1) {
      this.page = value
      let params = {
        page: this.page,
        ordering: this.ordering,
        search: this.searchForm.name
      }
      getSysUserList(params).then(res => {
        let resultsTmp = []
        res.data.results.map((item, index) => {
          if (item.os === 0) {
            item['btnEnabled'] = false
          } else {
            item['btnEnabled'] = false
          }
          resultsTmp.push(item)
        })
        this.tableData = resultsTmp
        this.count = res.data.count
      })
    },
    getAssetOptions () {
      getOpsCenterAllServer().then(res => {
        this.assetOptions = res.data
      })
    },
    addUser () {
      this.formItem.id = null
      this.change = true
    },
    editUser (params) {
      this.keyInitValue = '0'
      // 取当前行数据 赋值 给表单
      getSysUserDetail(params.row.id).then(res => {
        this.formItem.username = res.data.username
        this.formItem.sudo = res.data.sudo
        this.formItem.shell = res.data.shell
        this.formItem.description = res.data.description
        this.formItem.private_key = res.data.private_key
        this.formItem.name = res.data.name
        this.formItem.id = res.data.id
        this.formItem.os = res.data.os.toString()
        this.change = true
      })
    },
    pushUser (params) {
      // let os = null
      this.formItemPush.system_user_name = params.row.username
      this.formItemPush.system_user = params.row.id
      this.changePush = true
      // 根据系统用户关联的操作系统把资产为linux的主机筛选出来
      // let tableDataSel = []
      // tableDataSel = this.tableData.filter(item => {
      //   return item['id'] === params.row.id
      // })
      // if (tableDataSel) {
      //   os = tableDataSel[0].os
      // }
      let paramsA = {
        os: params.row.os
      }
      getOpsCenterAllServer(paramsA).then(res => {
        this.assetOptions = res.data
      })
    },
    deleteUser (id) {
      deleteSysUser(id).then(res => {
        if (res.data.code === 200) {
          this.$Message.success(res.data.msg)
          this.getSystemUserList()
        } else {
          this.$Message.error(res.data.msg)
        }
      })
    },
    drawerClose () {
      let that = this.formItem
      that.username = ''
      that.name = ''
      that.description = ''
      that.private_key = ''
      // that.sudo = ''
      // that.shell = ''
      that.id = null
    },
    drawerPushClose () {
      let that = this.formItemPush
      that.system_user_name = ''
      that.system_user = ''
      that.assets = []
    },
    changeSort (column) {
      if (column.key === 'id') {
        if (column.order === 'asc') {
          this.ordering = 'id'
        } else {
          this.ordering = '-id'
        }
      }
      this.getSystemUserList()
    },
    searchReset () {
      this.searchForm.name = null
    },
    onSelectKey (value) {
      if (value === '1') {
        this.keyVisible = true
      } else {
        this.keyVisible = false
      }
    },
    onSelectOs (value) {
      if (value === '0') {
        this.sudoVisible = true
        this.keyEditVisible = true
        this.shellVisible = true
      } else if (value === '1') {
        this.sudoVisible = false
        this.keyEditVisible = false
        this.shellVisible = false
      }
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.changeLoadingShow = true
          if (this.formItem.id) {
            editSysUser(this.formItem).then(res => {
              if (res.data.id > 0) {
                this.change = false
                this.getSystemUserList()
              } else {
                // this.$Notice.error({title: res.data})
                this.$Message.error(res.data)
              }
            }).catch(res => {
              console.log(res.response)
              this.$Notice.error({
                title: '操作失败！ 错误状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          } else {
            saveSysUser(this.formItem).then(res => {
              if (res.data.id > 0) {
                this.change = false
                this.getSystemUserList()
              } else {
                // this.$Notice.error({title: res.data})
                this.$Message.error(res.data)
              }
            }).catch(res => {
              console.log(res.response)
              this.$Notice.error({
                title: '操作失败！ 错误状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          }
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
        this.changeLoadingShow = false
      })
    },
    handlePushSubmit (name) {
      this.$Loading.start()
      this.$refs[name].validate((valid) => {
        if (valid) {
          pushSysUser(this.formItemPush).then(res => {
            if (res.data.id > 0) {
              this.changePush = false
              this.formItemPush.assets = []
              this.getSystemUserList()
            } else {
              // this.$Notice.error({title: res.data})
              this.formItemPush.assets = []
              this.$Message.error(res.data)
            }
          }).catch(res => {
            console.log(res.response)
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
      })
    }
  },
  mounted: function () {
    this.getSystemUserList()
    this.getAssetOptions()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
